import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconForward15$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconForward15 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7bb13a5506e8aab17fda79dc752deace5646173d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6e35fb5de5044f397cda367964c8a5da1a693ce8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd44ae2b82665be1e8bba7ac69ed19766e6176520', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.372 6.472H14V4.2a.5.5 0 0 1 .853-.354l3.033 3.024a.5.5 0 0 1 0 .706l-3.032 3.052a.5.5 0 0 1-.854-.352v-2.3H9.372a3.6 3.6 0 0 0-3.662 3.358 3.32 3.32 0 0 0 .939 2.473 3.7 3.7 0 0 0 1.926 1.015.51.51 0 0 1 .425.493v.532a.51.51 0 0 1-.587.5 5 5 0 0 1-2.841-1.493 4.85 4.85 0 0 1-1.362-3.565 5.11 5.11 0 0 1 5.162-4.817m8.497 9.328a1.468 1.468 0 0 1-1.64 1.47 1.407 1.407 0 0 1-1.54-1.2.192.192 0 0 1 .21-.24h.74c.091.004.17.064.2.15a.42.42 0 0 0 .39.23.475.475 0 1 0-.33-.81.2.2 0 0 1-.15.07h-.76a.23.23 0 0 1-.24-.24v-2.01a.23.23 0 0 1 .24-.24h2.42a.23.23 0 0 1 .24.24v.54a.23.23 0 0 1-.24.24h-1.53v.53c.2-.094.419-.142.64-.14a1.33 1.33 0 0 1 1.35 1.41m-3.72 1.15v-.621a.23.23 0 0 0-.239-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a1 1 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.23.23 0 0 0 .24.24h2.309a.23.23 0 0 0 .24-.24", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-forward-15", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-forward-15"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-forward-15":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconForward15$1);
            }
            break;
    } });
}

const CosmosIconForward15 = CosmosIconForward15$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconForward15, defineCustomElement };
